import { useState } from 'react';
import { adminApi } from './api';

// Can be embedded in an existing form: intentionally no nested <form>.
export default function ModuleQuickCreate({
  onCreated,
  label = '+ Nouvelle matière',
}) {
  const [open, setOpen] = useState(false);
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  async function create() {
    if (!name.trim() || busy) return;
    setError('');
    setBusy(true);
    try {
      const module = await adminApi.createModule({
        matiere: name.trim(),
        description: description.trim() || null,
      });
      await onCreated?.(module);
      setName('');
      setDescription('');
      setOpen(false);
    } catch (err) {
      setError(err.message || 'Impossible de créer la matière.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="bo-module-inline">
      <button type="button" className="bo-button bo-button--ghost bo-button--compact"
        onClick={() => setOpen((v) => !v)}>
        {open ? 'Annuler la nouvelle matière' : label}
      </button>
      {open && (
        <div className="bo-module-inline__fields">
          <label>
            Nom de la nouvelle matière
            <input className="bo-input" maxLength="255" value={name}
              onChange={(e) => setName(e.target.value)} placeholder="Ex. Culture générale" />
          </label>
          <label>
            Description (facultative)
            <input className="bo-input" maxLength="4000" value={description}
              onChange={(e) => setDescription(e.target.value)} />
          </label>
          <button type="button" className="bo-button bo-button--secondary"
            disabled={busy || !name.trim()} onClick={create}>
            {busy ? 'Création…' : 'Enregistrer la matière'}
          </button>
        </div>
      )}
      {error && <p role="alert" className="bo-alert bo-alert--error">{error}</p>}
    </div>
  );
}
